<span class="span-etapa">CONTACTO / FORO /</span><span class="span-vista"> DETALLE CONSULTA</span>
<table  >
    <tr>
        <td><h1>Detalle consulta</h1> </td>
        <td style="text-align: right;">
            <button class="btn-volver" mat-raised-button (click)="irA()">
                <span class="material-icons">arrow_back</span>
                Volver
            </button>
        </td>
    </tr>
</table>
<div class="cargando"><mat-spinner *ngIf="cargando"></mat-spinner></div>
<table class="contenido" *ngIf="!cargando">
    <tr>
        <td>
            <table class="table-consulta">
                <tr>
                    <td><h3>Asunto:</h3></td>
                    <td><input type="text" [(ngModel)]="detalleConsulta.asunto" disabled></td>
                </tr>
    
            </table>
            
            <h3>Consulta:</h3>
            <div class="div-pregunta">{{detalleConsulta.pregunta}}</div>
            <table>
                <tr>
                    <td style="width: 60%;"><span class="span-info">{{detalleConsulta.usuario}}</span> / <span class="span-info">{{detalleConsulta.nombres}}</span></td>
                    <td style="text-align: right;"><span class="span-info">{{detalleConsulta.fecha | date:'dd-MM-y HH:mm'}}</span></td>
                </tr>
            </table>
             

            <h3>Respuestas:</h3>
            <div *ngFor="let item of detalleConsulta.respuestas" style="padding-bottom: 3%;"> 
                <div class="div-respuestas">{{item.respuesta}}</div>
                <table>
                    <tr>
                        <td style="width: 60%;"><span class="span-info">{{item.usuario}}</span> / <span class="span-info">{{item.nombre}}</span></td>
                        <td style="text-align: right;"><span class="span-info">{{item.fecha | date:'dd-MM-y HH:mm'}}</span></td>
                    </tr>
                </table>
            </div>

            <br>
            
            <p>
                <b>Si tiene una nueva observación sobre la consulta ya ingresada escríbala a continuación:</b>
            </p>
            <form [formGroup]="formObservacion" autocomplete="on" novalidate 
                        (ngSubmit)="enviarObservacion(formObservacion.value)" style="text-align: right;"> 
                
                <mat-form-field appearance="fill">
                    <textarea matInput formControlName="respuesta" id="respuesta"></textarea>
                    <mat-error *ngIf="hasError('respuesta', 'required')">Observacion es requiredo</mat-error>
                </mat-form-field>            
                <br>                             
                <button mat-button class="btn-confirmar">Enviar</button>             
            </form> 
            <br> 
        </td>
        <td>
            <div class="informacion-contacto">
                <p>
                    Si tiene alguna consulta respecto a la implementación del MGCEP, 
                    favor contactar al equipo de implementación al número <b>800 100 116</b> o bien escribir al correo electrónico <b>consultas_mgcep@iie.cl</b>
                </p>
            </div>
        </td>
    </tr>
</table>
